import { Box, Typography, Paper } from '@mui/material';
import FarmAppLogo from '../../assets/logo/FarmAppLogo.png';
import { useTranslation } from 'react-i18next';

const SatelliteDataReportHeader = () => {
  const { t } = useTranslation();

  return (
    <Paper
      sx={{
        bgcolor: '#237D41',
        color: 'white',
        px: 2,
        py: 2.5,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        borderRadius: 0,
        boxShadow: 0,
        '@media print': {
          padding: '3mm 2mm',
          backgroundColor: '#237D41 !important',
          color: 'white !important',
          boxShadow: 'none',
          pageBreakInside: 'avoid',
        },
      }}
    >
      <Box>
        <Typography
          sx={{
            fontSize: '22px',
            fontWeight: '300',
            '@media print': {
              fontSize: '5mm',
            },
          }}
        >
          {t('Summary report for your')}
        </Typography>
        <Typography
          variant="h4"
          sx={{
            fontWeight: 'bold',
            '@media print': {
              fontSize: '8mm',
            },
          }}
        >
          {t('FARM')}
        </Typography>
      </Box>
      <Box
        component="img"
        src={FarmAppLogo}
        alt="Farm App Logo"
        sx={{
          width: 90,
          height: 'auto',
          bgcolor: 'white',
          padding: '8px 40px',
          borderRadius: 1,
          '@media print': {
            width: '20mm',
            padding: '1.5mm 8mm',
            backgroundColor: 'white !important',
          },
        }}
      />
    </Paper>
  );
};

export default SatelliteDataReportHeader;
